import React, {PropsWithChildren, useState, useMemo} from 'react';
import {
  View,
  ViewStyle,
  ScrollView,
  StyleSheet,
  LayoutChangeEvent,
  useWindowDimensions,
} from 'react-native';
import {corner_radius, spacing} from 'theme/Units';
import colors from 'theme/Colors';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';
import {Header} from 'components/common/Layout/Header';
import LinearGradient from 'react-native-linear-gradient';
import {useResponsiveStyles} from 'hooks/useResponsiveStyles';
import {mobileViewportWidth} from 'constants/DefaultValues';

export const ScreenWithLayout: React.FC<
  PropsWithChildren<NativeStackScreenProps<RootNavigatorParams>>
> = props => {
  const {children, ...rest} = props;
  const [gradientHeight, setGradientHeight] = useState<number>(0);
  const {width: screen_width} = useWindowDimensions();
  const styles = useResponsiveStyles<styleTypes>(baseStyles, responsive);

  let contentHeight = useMemo<number>(
    () => gradientHeight - Number(styles.main.padding) * 2,
    [gradientHeight, styles.main.padding],
  );

  function onGradientLayout(event: LayoutChangeEvent) {
    setGradientHeight(event.nativeEvent.layout.height);
  }

  const gradientColors =
    screen_width >= mobileViewportWidth
      ? [`${colors.palette.brandPink}33`, `${colors.palette.brandBlue}33`]
      : [colors.palette.white, colors.palette.white];

  return (
    <View style={styles.container}>
      <Header {...rest} />
      {/* <Navbar navigate={navigate} /> */}
      <LinearGradient
        start={{x: 0, y: 0}}
        end={{x: 1, y: 1}}
        colors={gradientColors}
        onLayout={onGradientLayout}
        style={styles.gradient}>
        <ScrollView style={styles.main} showsVerticalScrollIndicator={false}>
          {/* the content height can only be pased via inline style */}
          <View
            style={[
              styles.content,
              contentHeight > 0 ? {minHeight: contentHeight} : null,
            ]}>
            {children}
          </View>
        </ScrollView>
      </LinearGradient>
    </View>
  );
};

type styleTypes = {
  container: ViewStyle;
  main: ViewStyle;
  content: ViewStyle;
  gradient: ViewStyle;
};
const baseStyles: styleTypes = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    flex: 1,
    zIndex: -10,
  },
  main: {
    flexGrow: 1,
    padding: spacing['5'],
  },
  content: {
    flex: 1,
    width: '100%',
    minHeight: '90vh',
    backgroundColor: colors.palette.white,
    borderRadius: corner_radius['rounded-md'],
  },
});

const responsive: Record<number, Partial<styleTypes>> = {
  980: {
    main: {
      padding: spacing['6'],
    },
  },
  720: {
    main: {
      padding: spacing['4'],
    },
  },
  [mobileViewportWidth]: {
    main: {
      padding: 0,
    },
    content: {
      borderRadius: 0,
    },
  },
};
